import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Location } from "@angular/common";

@Component({
  selector: "app-loan-review-success",
  templateUrl: "./loan-review-success.component.html",
  standalone:false,
  styleUrls: ["./loan-review-success.component.scss"],
})
export class LoanReviewSuccessComponent implements OnInit {
  constructor(private router: Router, private location: Location) {}

  ngOnInit(): void {}

  dashboard() {
    this.router.navigateByUrl("/Dashboard");
  }
}
